import React from "react";
import DownloadAppSection from "./DownloadAppSection";
import SecondaryActionCard from "./SecondaryActionCard";

const SubscriptionComponent = ({
  isSubscriptionEnded,
  daysLeftToSubscriptionEnding,
  handlePaymentProcess,
  handleSignOut,
}) => {
  return (
    <section className="dashboard__container">
      {isSubscriptionEnded ? (
        <div
          className="dashboard__container__content__section__primary"
          style={{ backgroundColor: "#ff5145" }}
        >
          <h3 className="dashboard__container__content__section__primary__heading">
            {Math.abs(daysLeftToSubscriptionEnding)} Days before your
            subscription ended
          </h3>
          <button
            className="btn btn-md dashboard__container__content__section__primary__button"
            onClick={handlePaymentProcess}
          >
            Re-subscribe Now
          </button>
        </div>
      ) : (
        <div className="dashboard__container__content__section__primary">
          <h3 className="dashboard__container__content__section__primary__heading">
            {daysLeftToSubscriptionEnding} Days to subscription end
          </h3>
        </div>
      )}

      {!isSubscriptionEnded ? <DownloadAppSection /> : ""}

      <hr className="dashboard__container__hr" />

      <div className="dashboard__container__content">
        <SecondaryActionCard
          heading="View my website"
          subheading="See how it looks to the visitors"
          cta="Visit the website"
          link="/gym/abc"
        />

        <SecondaryActionCard
          heading="View the product"
          subheading="Take a look at how we help you run your digital gym smoothly."
          cta="Show me the product"
          link="/showcase"
        />

        <SecondaryActionCard
          heading="Sales helps."
          subheading="Having issues understanding our product? Talk to our sales team."
          cta="Take to sales"
          link="tel:8072937581"
        />
      </div>
      <div className="dashboard__container__footer">
        <button
          className="btn btn-sm dashboard__container__footer__button"
          onClick={handleSignOut}
        >
          Log out
        </button>
      </div>
    </section>
  );
};

export default SubscriptionComponent;
